// extracted by mini-css-extract-plugin
export default {"container":"OfficialTag_container__jPivj","avatar":"OfficialTag_avatar__osotQ","name":"OfficialTag_name__e4ubL"};